/**
 * Documents Tour
 *
 * Introduces users to document management — upload, organize, and
 * attach documents to cases.
 */

import type { TourConfig } from './tour-config.types';

export const documentsTour: TourConfig = {
  id: 'documents-overview',
  title: 'tours.documents.title',
  portal: 'business',
  steps: [
    {
      target: '[data-astor-id="documents-container"]',
      content: 'tours.documents.steps.overview',
      placement: 'bottom',
      route: '/documents',
    },
    {
      target: '[data-astor-id="documents-verification-status"]',
      content: 'tours.documents.steps.verification',
      placement: 'bottom',
      route: '/documents',
    },
    {
      target: '[data-astor-id="documents-signing-queue"]',
      content: 'tours.documents.steps.signingQueue',
      placement: 'bottom',
      route: '/documents/signing',
    },
    {
      target: '[data-astor-id="documents-retained-copies"]',
      content: 'tours.documents.steps.retainedCopies',
      placement: 'bottom',
      route: '/documents/retained-copies',
    },
  ],
};
